import "reset.css";
import "./style.scss";

import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import store from "common/store";
import "common/assets/js/firebase";
import App from "App";


class Root extends Component {
  render() {
    return (
      <Provider store={store}>
        <App />
      </Provider>
    );
  }
}

ReactDOM.render(<Root />, document.getElementById("root"));
